import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import styles from './styles.module.css';

interface DeleteConfirmationModalProps {
  onClose: () => void;
  open: boolean;
  titleItem?: any;
  onDelete: () => void;
  loading: boolean;
  textMessage?: string;
  acceptButtonText?: string;
}

export const DeleteConfirmationModal = ({
  onClose,
  open,
  titleItem,
  onDelete,
  loading,
  textMessage = 'Are you sure you want to delete',
  acceptButtonText = 'DELETE',
}: DeleteConfirmationModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent sx={{ padding: 5 }}>
        <div className={styles.content}>
          <WarningRoundedIcon sx={{ fontSize: 70 }} color="error" />
          <Typography variant="h5">
            {textMessage}{' '}
            <span style={{ fontWeight: 'bold' }}>{titleItem || ''}</span>?
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose}>
          CANCEL
        </Button>
        <LoadingButton
          loading={loading}
          color="error"
          variant="contained"
          onClick={onDelete}
          autoFocus
        >
          {acceptButtonText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
